import { render, staticRenderFns } from "./Slide1.vue?vue&type=template&id=d72a748c&scoped=true&"
import script from "./Slide1.vue?vue&type=script&lang=js&"
export * from "./Slide1.vue?vue&type=script&lang=js&"
import style0 from "./Slide1.vue?vue&type=style&index=0&id=d72a748c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72a748c",
  null
  
)

export default component.exports